import CompletePage from 'containers/CompletePage/CompletePage'
import InfoPage from 'containers/InfoPage/InfoPage'
import LanguagePage from 'containers/LanguagePage/LanguagePage'
import PageFlowManager from 'containers/PageFlowManager/PageFlowManager'
import QuestionFlowManager from 'containers/QuestionFlowManager/QuestionFlowManager'
import QuestionnairePage from 'containers/QuestionnairePage/QuestionnairePage'
import AppStateProvider from 'containers/State/AppState'
import TermsPage from 'containers/TermsPage/TermsPage'
import IntlProvider from 'intl/IntlProvider'
import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Route, Routes } from 'react-router-dom'
import { initDatadogLogs } from 'utils/datadog'

const App = () => {
  initDatadogLogs()

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY ?? ''}
      language="en-GB"
      useEnterprise
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
        nonce: undefined // optional, default undefined
      }}
    >
      <AppStateProvider>
        <IntlProvider>
          <PageFlowManager>
            <Routes>
              <Route path="/language" element={<LanguagePage />} />
              <Route path="/info" element={<InfoPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route
                path="/questionnaire"
                element={
                  <QuestionFlowManager>
                    <QuestionnairePage />
                  </QuestionFlowManager>
                }
              />
              <Route path="/complete" element={<CompletePage />} />
            </Routes>
          </PageFlowManager>
        </IntlProvider>
      </AppStateProvider>
    </GoogleReCaptchaProvider>
  )
}

export default App
